import { render, staticRenderFns } from "./EditMain.vue?vue&type=template&id=4288de1c"
import script from "./EditMain.vue?vue&type=script&lang=js"
export * from "./EditMain.vue?vue&type=script&lang=js"
import style0 from "./EditMain.vue?vue&type=style&index=0&id=4288de1c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports